import type { ReactNode } from 'react';
import { Label } from '@/components/ui/label';
import type { GuideTopicId } from '../content/topics';
import { FieldHelp } from './FieldHelp';

interface HelpLabelProps {
  topicId: GuideTopicId;
  htmlFor?: string;
  /** Extra classes for the label itself, not the row. */
  className?: string;
  children: ReactNode;
}

/**
 * A field label with its help icon beside it.
 *
 * Seating the icon next to a label is one layout decision, and it was being
 * re-made at every call site. Keeping it here means the spacing, and later the
 * alignment on labels that wrap to two lines, are changed in one place.
 */
export function HelpLabel({
  topicId,
  htmlFor,
  className,
  children,
}: HelpLabelProps) {
  return (
    <div className="flex items-center gap-2">
      <Label htmlFor={htmlFor} className={className}>
        {children}
      </Label>
      <FieldHelp topicId={topicId} />
    </div>
  );
}
